import * as THREE from 'three';

export class MyCube extends THREE.Mesh{
    //触发标志
    #switch_flag = false;
    //闪烁标志，主要防止在触发标志为false时，程序还在为color和depthTest赋值。
    #twinkling_flag = false;
    //闪烁间隔时间，即一亮一暗的间隔时间
    #twinkling_inter = 300;
    //闪烁方式，0:间隔 1:连续
    #twinkling_style = 0;

    constructor(){
        const geometry = new THREE.BoxGeometry(); // 立方体几何体（长宽高均为size）
        const material = new THREE.MeshStandardMaterial({ color: 0xff0000});
        super(geometry, material); // 必须先调用super()，再访问this
        this.renderOrder = 10; 
    }

    setTwinklingStyle(_style){
        this.#twinkling_style = _style;
    }

    getTwinklingStyle(){
        return this.#twinkling_style;
    }
    
    open() {
        this.#switch_flag = true;
        this.#twinkling_flag = true;
    }

    close(){
        this.#switch_flag = false;
    }

    isOpen() {
        return this.#switch_flag;
    }

    //控制闪烁
    twinkling(){
        if(!this.#twinkling_flag){
            return ;
        }
        if(this.isOpen()){
            this.material.color.r = this.#twinklingValue(); 
            this.material.depthTest = false;
        }else{
            this.material.color.r = 1.0; 
            this.material.depthTest = true;
            //关闭闪烁
            this.#twinkling_flag = false;
        }
    }

    //获取闪烁颜色的值
    #twinklingValue(){
        const currentTime = Date.now();
        if(this.#twinkling_style == 0){
            return (currentTime % (this.#twinkling_inter*2)>this.#twinkling_inter)? 6.0 : 1.0
        }else{
            return Math.abs(Math.sin(currentTime/300)) * 5.0;
        }
    }
}
//export default MyCube;